module.exports = __webpack_public_path__ + "media/images/home/marketposters_logo__-9b0fba3a3ace0106264f3fc2be09cbdc.png";